import { gql } from '../../../../__generated__/graphql/catalog'

export const FETCH_FIT_MODELS = gql(`
  query FetchFitModels($handle: String!, $preview: Boolean) {
    fitModels(handle: $handle, isPreview: $preview) {
      nodes {
        description
        name
        height
        images
        pantsSize
        topSize
      }
    }
  }
`)
